/*** IMPORTS FROM imports-loader ***/
var define = false;

// Packages
import 'bootstrap';
import 'slick-carousel';
import 'waypoints';

// Frameworks
import './frameworks/filterizr.js'; import './frameworks/modernizr-object-fit.js';

// Includes
import './includes/animation.js'; import './includes/lightbox.js'; import './includes/menu.js'; import './includes/object-fit.js'; import './includes/slider.js'; import './includes/typo.js';

// Components
import '../../components/accordions/script.js'; import '../../components/filter/script.js'; import '../../components/hero_slider/script.js'; import '../../components/number_counter/script.js'; import '../../components/rooms/script.js'; import '../../components/slider_image/script.js'; import '../../components/slider_quote/script.js'; import '../../components/slider_text/script.js'; import '../../components/tabs/script.js';

